module.exports = __webpack_public_path__ + "img/undraw_Scrum_board_re_wk7v.789c9ad3.svg";